export default function prepareBase64File(extension, base64File) {
  const types = {
    JPG: `data:image/jpeg;base64,${base64File}`,
    JPEG: `data:image/jpeg;base64,${base64File}`,
    PDF: `data:application/pdf;base64,${base64File}`,
    PNG: `data:image/png;base64,${base64File}`,
    TIFF: `data:image/tiff;base64,${base64File}`,
    CSV: `data:application/csv;base64,${base64File}`,
  };

  if (extension) return types[extension.split('.')[1].toUpperCase()];
  return null;
}
